import get from "lodash/get";

export const SET_RB_VISITOR_ID = "SET_RB_VISITOR_ID";

const defaultState = null;

export const reducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case SET_RB_VISITOR_ID: {
      const payload = get(action, "payload");

      return payload || "";
    }
    default:
      return state;
  }
};

export const setRbVisitorID = (rbVisitorID) => {
  return {
    type: SET_RB_VISITOR_ID,
    payload: rbVisitorID,
  };
};
